const verticalExamples = {
  beauty: {
    label: 'Salón de belleza',
    crm: {
      pipeline: 'Una oportunidad es un prospecto que agendó cita. Un lead es alguien que preguntó por WhatsApp o web.',
      entrantes: 'Entrantes son mensajes que llegan por Fuentes de Leads. Leads CRM son prospectos ya en seguimiento.',
      attribution: 'Medio: WhatsApp. Canal: widget web. Campaña: Promo Verano.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Uñas" y "Equipo Spa". Asigna leads de manicure al equipo Uñas y masajes al equipo Spa.',
    },
    crm_contact_persistence: {
      example: 'Una clienta que llamó por uñas y luego volvió a preguntar por spa: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña "Promo Verano" para uñas en Sucursal Polanco se asignan al equipo Uñas de esa sucursal.',
    },
    training: 'Configura un asistente llamado "Sofía" con tono amigable. Objetivos: agendar citas, informar servicios y precios. Guardarrail: no recomendar tratamientos médicos.',
    knowledge: 'Sube tu catálogo de servicios (PDF) con precios, lista de estilistas y horarios. El bot responderá consultas como "¿Cuánto cuesta un corte + tinte?".',
    skills: 'Crea una habilidad "Consultar disponibilidad" que busque en el catálogo y sugiera horarios libres.',
    tools: 'Registra herramienta "Buscar servicios" con input: {query: string}. Valida con dry-run.',
    mcp: 'Conecta un servidor MCP de tu sistema de agenda para sincronizar disponibilidad de citas.',
    orchestrator: 'Ejecuta "Buscar servicios" en sandbox. Prueba con dry-run primero. Si todo funciona, habilita producción.',
    campaigns: 'Crea una campaña "Promo Verano" con descuento 20% en servicios. Canal WhatsApp con variables {{nombre}} y {{servicio}}.',
    schedules: 'Programa la campaña para enviar el lunes a las 10am. Crea snapshot de audiencia "Clientes activos", ejecuta preflight y marca listo.',
    delivery: 'Crea delivery plan desde schedule listo. Dry-run valida sin enviar. Test-send a contacto interno del equipo comercial.',
  },
  health: {
    label: 'Clínica de salud',
    crm: {
      pipeline: 'Oportunidad: paciente que solicitó presupuesto. Lead: persona que consultó disponibilidad.',
      entrantes: 'Entrantes son consultas nuevas. Leads CRM son pacientes en proceso de agendar.',
      attribution: 'Medio: email. Canal: formulario web. Campaña: Check-up Anual.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Odontología" y "Equipo Nutrición". Los leads de dieta van a Nutrición, los de ortodoncia a Odontología.',
    },
    crm_contact_persistence: {
      example: 'Un paciente que consultó odontología y luego pidió nutrición: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de formulario "Check-up Anual" con sede Centro se asignan al equipo de consulta general de esa sede.',
    },
    training: 'Asistente "Dr. Asistente" con tono profesional y empático. Guardarrail: nunca dar diagnósticos, siempre recomendar consulta presencial.',
    knowledge: 'Sube guías de servicios, preguntas frecuentes y políticas de cancelación.',
    skills: 'Habilidad "Responder FAQ médica" con knowledge_scope limitado a preguntas frecuentes aprobadas.',
    tools: 'Herramienta "Buscar FAQ" para consultas rápidas sin riesgo.',
    mcp: 'Conecta tu sistema de expedientes (solo lectura) para verificar citas existentes.',
    orchestrator: 'Ejecuta consultas en sandbox. Para operaciones con datos de pacientes, usa aprobación obligatoria.',
    campaigns: 'Campaña recordatorio de citas. Canal email con {{nombre_paciente}} y {{fecha_cita}}. Tono profesional.',
    schedules: 'Programa recordatorios 24h antes de cada cita. Snapshot solo con pacientes opted_in. Preflight verifica consentimiento estricto.',
    delivery: 'Dry-run validación recordatorio citas. Test-send a contacto interno de admisiones con consent opted_in.',
  },
  fitness: {
    label: 'Gimnasio / Centro fitness',
    crm: {
      pipeline: 'Oportunidad: prospecto que visitó el gym. Lead: alguien que preguntó por membresías.',
      entrantes: 'Entrantes son consultas de redes/web. Leads CRM son prospectos en proceso de inscripción.',
      attribution: 'Medio: Instagram. Canal: DM. Campaña: Mes de prueba.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Membresías" y "Equipo Clases". Leads de inscripción van a Membresías, yoga/pilates a Clases.',
    },
    crm_contact_persistence: {
      example: 'Un prospecto que preguntó por membresía y luego por clases grupales: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña "Mes de prueba" vía Instagram se asignan al equipo de membresías.',
    },
    training: 'Asistente "Coach IA" con tono motivador. Objetivos: informar clases, membresías y horarios.',
    knowledge: 'Sube horarios de clases, lista de entrenadores y planes de membresía.',
    skills: 'Habilidad "Recomendar clase" que busque clases por horario y nivel.',
    tools: 'Herramienta "Buscar clases disponibles" con filtros de día y tipo.',
    mcp: 'Conecta tu sistema de reservas para consultar disponibilidad en tiempo real.',
    orchestrator: 'Prueba recomendaciones en sandbox antes de activar en producción.',
    campaigns: 'Campaña "Mes de prueba gratis". Canal WhatsApp con {{nombre}} y {{clase_recomendada}}.',
    schedules: 'Programa promociones de inicio de mes. Snapshot de miembros activos, preflight verifica opt-in de WhatsApp.',
    delivery: 'Prueba envío campaña mes gratis con contacto test interno. Dry-run primero, luego test-send controlado.',
  },
  education: {
    label: 'Escuela / Centro educativo',
    crm: {
      pipeline: 'Oportunidad: prospecto que asistió a cita informativa. Lead: padre que consultó inscripción.',
      entrantes: 'Entrantes son consultas de la web escolar. Leads CRM son prospectos en proceso de admisión.',
      attribution: 'Medio: landing page. Canal: formulario. Campaña: Inscripciones 2026.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Admisiones" y "Equipo Idiomas". Leads de inglés van a Idiomas, los de inscripción general a Admisiones.',
    },
    crm_contact_persistence: {
      example: 'Un padre que preguntó por preescolar y luego por primaria: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña "Inscripciones 2026" con sede Campus Norte se asignan al equipo de admisiones de esa sede.',
    },
    training: 'Asistente "Tutor Virtual" con tono paciente y didáctico. Guardarrail: no hacer tareas por los alumnos.',
    knowledge: 'Sube reglamentos, calendarios escolares y guías de inscripción.',
    skills: 'Habilidad "Consultar calendario" que busque fechas importantes por periodo.',
    tools: 'Herramienta "Buscar información escolar" para consultas de padres de familia.',
    mcp: 'Conecta tu plataforma de gestión escolar para consultar calificaciones (solo lectura).',
    orchestrator: 'Ejecuta consultas informativas en sandbox. Datos académicos requieren aprobación.',
    campaigns: 'Campaña inscripciones abiertas. Canal email con {{nombre_alumno}} y {{periodo}}. Incluye link de registro.',
    schedules: 'Programa avisos de inscripción 2 semanas antes. Snapshot de alumnos inscritos, preflight confirma emails válidos.',
    delivery: 'Dry-run inscripciones abiertas. Test-send a contacto del equipo de admisiones.',
  },
  automotive: {
    label: 'Taller / Agencia automotriz',
    crm: {
      pipeline: 'Oportunidad: lead con cotización. Lead: persona que preguntó por un modelo.',
      entrantes: 'Entrantes son formularios de agencia. Leads CRM son prospectos con interés confirmado.',
      attribution: 'Medio: portal autos. Canal: API. Campaña: SUV 2026.',
    },
    assignment_pools: {
      example: 'Crea "Unidades nuevas" y "Seminuevos". Leads zero km van a nuevas, los de usados a Seminuevos.',
    },
    crm_contact_persistence: {
      example: 'Un prospecto que cotizó un SUV y luego preguntó por financiamiento: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña "SUV 2026" en Sede Norte se asignan al equipo de unidades nuevas de esa sede.',
    },
    training: 'Asistente "Asesor de Servicio" con tono técnico pero accesible. Objetivos: cotizar servicios, agendar citas.',
    knowledge: 'Sube lista de servicios con precios, tiempo estimado y refacciones necesarias.',
    skills: 'Habilidad "Cotizar servicio" que busque en el catálogo por tipo de vehículo y servicio.',
    tools: 'Herramienta "Buscar servicios por vehículo" con input: {marca, modelo, servicio}.',
    mcp: 'Conecta tu sistema de inventario de refacciones para disponibilidad en tiempo real.',
    orchestrator: 'Prueba cotizaciones en sandbox. Órdenes de trabajo requieren aprobación.',
    campaigns: 'Campaña servicio preventivo. Canal SMS con {{nombre_cliente}}, {{vehiculo}} y {{km_siguiente_servicio}}.',
    schedules: 'Programa recordatorios de servicio por fecha. Snapshot de clientes con vehículos próximos a mantenimiento.',
    delivery: 'Prueba controlada campaña SUV 2026 a contacto test interno del taller.',
  },
  real_estate: {
    label: 'Inmobiliaria',
    crm: {
      pipeline: 'Oportunidad: lead que visitó propiedad. Lead: persona que solicitó información.',
      entrantes: 'Entrantes son consultas de portales inmobiliarios. Leads CRM son prospectos calificados.',
      attribution: 'Medio: portal inmobiliario. Canal: formulario. Campaña: Torre Norte preventa.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Preventa" y "Equipo Renta". Leads de desarrollo nuevo van a Preventa, los de renta a Renta.',
    },
    crm_contact_persistence: {
      example: 'Un prospecto que preguntó por un depa en preventa y luego por renta temporal: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña "Preventa Zona Esmeralda" con sede Satélite se asignan al equipo de desarrollos de esa zona.',
    },
    training: 'Asistente "Asesor Inmobiliario" con tono profesional. Objetivos: mostrar propiedades, agendar visitas.',
    knowledge: 'Sube catálogo de propiedades con precios, fotos, ubicación y características.',
    skills: 'Habilidad "Buscar propiedad" que filtre por presupuesto, zona y tipo.',
    tools: 'Herramienta "Filtrar propiedades" con input: {presupuesto_max, zona, tipo}.',
    mcp: 'Conecta tu CRM inmobiliario para sincronizar propiedades disponibles.',
    orchestrator: 'Ejecuta búsquedas en sandbox. Agendamiento de visitas requiere aprobación.',
    campaigns: 'Campaña nuevas propiedades. Canal email con {{nombre}}, {{zona}} y {{rango_precio}}.',
    schedules: 'Programa envíos semanales de nuevas propiedades. Snapshot de compradores interesados por zona.',
    delivery: 'Prueba preventa con contacto test del equipo comercial inmobiliario.',
  },
  professional_services: {
    label: 'Despacho profesional',
    crm: {
      pipeline: 'Oportunidad: prospecto con cotización. Lead: persona que consultó servicios.',
      entrantes: 'Entrantes son consultas del sitio web. Leads CRM son prospectos en negociación.',
      attribution: 'Medio: referido. Canal: email. Campaña: Declaración anual.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Legal" y "Equipo Contable". Leads fiscales van a Contable, los de demandas a Legal.',
    },
    crm_contact_persistence: {
      example: 'Un cliente que consultó temas fiscales y luego pidió asesoría legal: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña "Declaración anual" por email se asignan al equipo contable.',
    },
    training: 'Asistente "Recepción Virtual" con tono formal. Objetivos: agendar consultas, informar servicios.',
    knowledge: 'Sube descripción de servicios, tarifas y políticas de confidencialidad.',
    skills: 'Habilidad "Consultar tarifas" que busque por tipo de servicio profesional.',
    tools: 'Herramienta "Buscar servicios profesionales" con input: {tipo_servicio, urgencia}.',
    mcp: 'Conecta tu sistema de agenda para consultar disponibilidad de los profesionales.',
    orchestrator: 'Prueba consultas en sandbox. Acceso a expedientes requiere aprobación.',
    campaigns: 'Campaña recordatorio de cita. Canal WhatsApp con {{nombre_cliente}} y {{tipo_consulta}}.',
    schedules: 'Programa recordatorios 48h antes de la cita. Preflight valida consentimiento WhatsApp de cada paciente.',
    delivery: 'Valida mensaje de seguimiento de tratamientos con test-send a contacto de recepción.',
  },
  generic: {
    label: 'Negocio general',
    crm: {
      pipeline: 'Oportunidad: lead con cotización enviada. Lead: contacto interesado.',
      entrantes: 'Entrantes son mensajes nuevos. Leads CRM son contactos en proceso comercial.',
      attribution: 'Medio: directo. Canal: teléfono. Campaña: general.',
    },
    assignment_pools: {
      example: 'Crea "Equipo Ventas" y "Equipo Soporte". Leads comerciales van a Ventas, consultas postventa a Soporte.',
    },
    crm_contact_persistence: {
      example: 'Un contacto que preguntó por ventas y luego por soporte: ambos leads se vinculan al mismo contacto.',
    },
    assignment_routing: {
      example: 'Leads de campaña general vía teléfono se asignan al equipo de ventas.',
    },
    training: 'Configura nombre, tono y objetivos de tu asistente. Define qué puede y qué no puede hacer.',
    knowledge: 'Sube documentos con información de tu negocio: servicios, precios, políticas, FAQ.',
    skills: 'Crea habilidades que conecten tu conocimiento con acciones específicas del bot.',
    tools: 'Registra herramientas con esquemas claros. Valida con dry-run antes de publicar.',
    mcp: 'Conecta servidores MCP externos para ampliar las capacidades de tu asistente.',
    orchestrator: 'Ejecuta herramientas en sandbox primero. Usa dry-run para verificar sin riesgo.',
    campaigns: 'Diseña una campaña con variables por canal. Usa preview para verificar antes de aprobar.',
    schedules: 'Programa tus campañas con fecha futura. Crea snapshots de audiencia, valida con preflight y marca listo cuando todo esté ok.',
    delivery: 'Crea delivery plan, ejecuta dry-run y envía test-send a contacto interno. Sin envío masivo.',
  },
};

export default verticalExamples;
